export default "__VITE_ASSET__uz8mfZhD__"